import React from "react";
import Mydata from "../data/privacy/privacy.json";
import Image from "next/image";
import TawkTo from "../componenets/Tawko";

import Cancel from "../../../public/updated-home/cancelletion/canncelltion.png";
function page() {
  const data = Mydata[0];
  const data1 = Mydata[1];
  return (
    <div>
      <TawkTo />
      <title>Terms and conditions for cancellation policy</title>
      <meta
        name="description"
        content="Read the cancellation policy to learn about our terms and conditions for upcoming reservation. Trust Prestige Ride and enjoy hassle-free experience."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/cancellation-and-refund-policy"
      />

      {/* =============================== */}
      <div style={{ background: "rgba(213, 175, 52, 0.1)" }}>
        <div className="mx-auto max-w-7xl pt-4 pb-4 px-6">
          <h1 className="text-2xl  mb-2 font-bold secondary">{data.title}</h1>
          <p className="updatedparapremu">{data.des}</p>
        </div>
      </div>
      {/* =============================== */}

      <div className="mx-auto  pt-8 max-w-7xl grid grid-cols-5 px-6 lg:gap-10">
        <div className="  col-span-12 sm:col-span-1 md:col-span-1 lg:col-span-2">
          <Image src={Cancel} alt="cancellation-policy" />
        </div>
        <div className="  col-span-12 sm:col-span-1 md:col-span-1 lg:col-span-3 ">
          <p className="updatedparapremu p-2">{data1.des}</p>
        </div>
      </div>
      {/* ============================================= */}

      <div className="mx-auto max-w-7xl  px-6 pt-6 mb-10">
        {data1.content.map((Object) => {
          return (
            <>
              <h2 className="updatedheading pb-2">{Object.title}</h2>
              <div
                className="pt-1 mb-2"
                dangerouslySetInnerHTML={{ __html: Object.des }}
              ></div>
            </>
          );
        })}
        <h2 className="updatedheading pb-2">6. Contact Information</h2>
        <p className="updatedparapremu pb-2">
          If you have any questions or concerns or require further information
          about our Cancellation and Refund Policy, contact us at {""}
          <a href="mailto:contact@prestigeride.com" id="highlight">
            contact@prestigeride.com
          </a>
          . We appreciate your business and value your satisfaction. Our
          Cancellation and Refund Policy is designed to be fair and transparent,
          and we are here to assist you with any inquiries or concerns you may
          have. Thank you for choosing{" "}
          <a id="highlight" href="/">
            PrestigeRide.com
          </a>{" "}
          for your transportation needs.
        </p>
      </div>

      {/* ============================================= */}
    </div>
  );
}

export default page;
